import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import { Modal } from 'react-bootstrap';

import { RestaurantAction, ProAccountAction } from 'actions';
import { RestaurantStore, ProAccountStore } from 'stores';

import { RestaurantsGroup } from 'PMT/entities/restaurantsGroup';
import { Restaurant } from 'PMT/entities';
import ProDomain from 'PMT/entities/security/ProDomain';

import ChooseRestaurantsGroupView from './ChooseRestaurantsGroupView';
import ChooseRestaurantView from './ChooseRestaurantView';
import ChooseProDomainView from './ChooseProDomainView';

/**
 */
export default class ChooseRestaurantsGroupModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  state = this.getDefaultState();

  getDefaultState() {
    const restaurantGroupList = RestaurantStore.getRestaurantsGroup();

    const selectedRestaurantGroup = RestaurantStore.getSelectedRestaurantsGroup();
    const selectedRestaurant = RestaurantStore.getRestaurant();

    const proDomainsList = ProAccountStore.getMeAccount().domainsList;

    const selectedProDomain = ProAccountStore.getSelectedProDomain();

    const haveMultipleDomains: boolean = ProAccountStore.getMeAccount().domainsList.domains.length > 0;

    const haveMultipleGroupsList: boolean = selectedRestaurantGroup.haveChilds();

    return {
      restaurantGroupList,
      selectedRestaurantGroup,
      selectedRestaurant,
      proDomainsList,
      selectedProDomain,
      displayDomainsList: haveMultipleDomains,

      // if there is only domain, we display directly the restaurants group list
      displayRestaurantsGroupList: !haveMultipleDomains && haveMultipleGroupsList,

      // if there is only one group without children, we display the restaurants list directly.
      displayRestaurantsList: !haveMultipleDomains && !haveMultipleGroupsList,
    }
  }

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  selectRestaurant(proDomain: ProDomain, restaurantGroup: RestaurantsGroup, restaurant: Restaurant) {
    ProAccountAction.changeProDomain(proDomain);
    RestaurantAction.retrieveRestaurantForGroup(restaurant, restaurantGroup);
    this.onClose();
  }

  //
  // Events
  //

  onProDomainClick = (selectedProDomain: ProDomain) => {
    const selectedProDomainRestaurantGroup = selectedProDomain.restaurantsGroup;
    // const selectedProDomainRestaurantGroup = RestaurantStore.getRestaurantsGroup();

    const displayDomainsList = false;

    // if there is only one group without children, we display the restaurants list directly.
    const displayRestaurantsGroupList = selectedProDomainRestaurantGroup.haveChilds();
    const displayRestaurantsList = !selectedProDomainRestaurantGroup.haveChilds();

    // only one restaurantsGroup with one restaurant, let's go!
    if (!selectedProDomainRestaurantGroup.haveChilds()
    && !selectedProDomainRestaurantGroup.haveMultipleRestaurants()) {
      // TODO: change when we have restaurant name
      const restaurant = new Restaurant();
      restaurant.id = selectedProDomainRestaurantGroup.restaurantsIds[0];
      this.selectRestaurant(selectedProDomain, selectedProDomainRestaurantGroup, restaurant);
      return;
    }

    this.setState({
      selectedProDomain,
      selectedRestaurantGroup: selectedProDomainRestaurantGroup,
      restaurantGroupList: selectedProDomain.restaurantsGroup,
      displayDomainsList,
      displayRestaurantsGroupList
    });
  };

  onRestaurantGroupClick = (selectedRestaurantGroup: RestaurantsGroup) => {
    // only one restaurant, let's go!
    if (selectedRestaurantGroup.restaurantsIds.length === 1) {
      // TODO: change when we have restaurant name
      const restaurant = new Restaurant();
      restaurant.id = selectedRestaurantGroup.restaurantsIds[0];
      this.selectRestaurant(this.state.selectedProDomain, selectedRestaurantGroup, restaurant);
      return;
    }

    this.setState({
      selectedRestaurantGroup,
      displayRestaurantsGroupList: false,
      displayRestaurantsList: true
    });
  };

  onRestaurantClick = (selectedRestaurant: Restaurant) => {
    this.selectRestaurant(this.state.selectedProDomain, this.state.selectedRestaurantGroup, selectedRestaurant);
  };

  onDisplayChooseRestaurantsGroupView = () => {
    this.setState({
      displayRestaurantsList: false,
      displayRestaurantsGroupList: true,
    });
  };

  //
  // renderers
  //

  renderBody() {
    return (
      <div className="choose_restaurants_group_modal">
        {this.state.displayDomainsList &&
          <ChooseProDomainView
            proDomainsList={this.state.proDomainsList}
            selectedProDomain={this.state.selectedProDomain}
            onClick={this.onProDomainClick}
          />
        }
        {this.state.displayRestaurantsGroupList &&
          <ChooseRestaurantsGroupView
            restaurantsGroup={this.state.restaurantGroupList}
            selectedRestaurantsGroup={this.state.selectedRestaurantGroup}
            onClick={this.onRestaurantGroupClick}
          />
        }
        {this.state.displayRestaurantsList &&
          <ChooseRestaurantView
            restaurantsGroup={this.state.selectedRestaurantGroup}
            onClick={this.onRestaurantClick}
            onPrevious={this.onDisplayChooseRestaurantsGroupView}
          />
        }
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.restaurants_group.choose.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ChooseRestaurantsGroupModal.js